import { DEAD_LOCK_MESSAGE, IS_DEAD_LOCK, RESET_STORE } from "../types";

const initialState = {
  isDead_lock: false,
  dead_lock_message: "",
};

export const deadLockreducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case IS_DEAD_LOCK:
      return { ...state, isDead_lock: payload };
    case DEAD_LOCK_MESSAGE:
      return { ...state, dead_lock_message: payload };
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};
